import * as yup from 'yup'

const simpplrAuthFormValidationSchema = yup
  .object()
  .shape({
    consumerKey: yup.string().trim().required('Consumer Token is required'),
    clientSecret: yup.string().trim().required('Client Secret is required')
  })
  .required()

export default simpplrAuthFormValidationSchema
